import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 1.24H3.75a2.1 2.1 0 0 0-2.09 1.89l-.4 4.71a2.13 2.13 0 0 0 .52 1.69 1.9 1.9 0 0 0 1.43.62h3.11l-.4 2.14A2.1 2.1 0 0 0 8 14.74 2.05 2.05 0 0 0 10 13l.53-2.88H14a.75.75 0 0 0 .75-.75V2a.76.76 0 0 0-.75-.76ZM8.54 12.78a.54.54 0 0 1-.55.46.6.6 0 0 1-.59-.68l.57-3a.75.75 0 0 0-.74-.89h-4a.39.39 0 0 1-.32-.13.7.7 0 0 1-.16-.54l.41-4.71a.59.59 0 0 1 .59-.54H9.2v6.48Zm4.71-4.12H10.7V2.74h2.55Z';
const draw24px =
  'M21,3.25H5.81A2.75,2.75,0,0,0,3.08,5.73h0l-.6,7A2.84,2.84,0,0,0,3.16,15a2.44,2.44,0,0,0,1.84.8h5.12l-.47,2.8a2.75,2.75,0,0,0,2.72,3.2A2.67,2.67,0,0,0,15,19.51l.63-3.76H21a.74.74,0,0,0,.75-.75V4A.75.75,0,0,0,21,3.25Zm-7.47,16a1.16,1.16,0,0,1-1.16,1,1.26,1.26,0,0,1-1-.44,1.24,1.24,0,0,1-.28-1l.61-3.67a.74.74,0,0,0-.16-.61.78.78,0,0,0-.58-.27H5a.94.94,0,0,1-.73-.3A1.42,1.42,0,0,1,4,12.87l.6-7A1.26,1.26,0,0,1,5.81,4.75h8.44V14.94Zm6.72-5h-4.5V4.75h4.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const ThumbsDownIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'thumbsDown'),
) as IconWithRender;

ThumbsDownIcon.displayName = 'ThumbsDownIcon';
ThumbsDownIcon.propTypes = Icon.propTypes;
ThumbsDownIcon.renderIcon = (props) => <ThumbsDownIcon {...props} />;
export default ThumbsDownIcon;
